/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { ref, onBeforeUnmount, Ref } from '@vue/composition-api';

/**
 * 倒计时 Hook
 * @param initialCount 初始倒计时秒数，默认为 3
 * @returns 返回倒计时状态和控制方法
 */
export function useCountDown(initialCount = 3, initialShow = false): {
  showCountDown: Ref<boolean>;
  countDown: Ref<number>;
  startCountDown: () => void;
  clearCountDown: () => void;
} {
  /** 倒计时秒数 */
  const countDown = ref<number>(initialCount);
  /** 是否展示倒计时 */
  const showCountDown = ref<boolean>(initialShow);
  /** 倒计时定时器 */
  let countDownTimer: ReturnType<typeof setTimeout> | null = null;

  /** 开始倒计时 */
  const startCountDown = () => {
    countDown.value = initialCount;
    showCountDown.value = true;

    if (countDownTimer) {
      clearTimeout(countDownTimer);
    }

    const tick = () => {
      countDown.value--;
      if (countDown.value > 0) {
        countDownTimer = setTimeout(tick, 1000);
      } else {
        countDown.value = 0;
        countDownTimer = null;
        showCountDown.value = false;
      }
    };

    countDownTimer = setTimeout(tick, 1000);
  };

  /** 清除倒计时 */
  const clearCountDown = () => {
    if (countDownTimer) {
      clearTimeout(countDownTimer);
      countDownTimer = null;
    }
    countDown.value = 0;
    showCountDown.value = false;
  };

  /** 组件卸载时清除定时器 */
  onBeforeUnmount(() => {
    clearCountDown();
  });

  return {
    countDown,
    showCountDown,
    startCountDown,
    clearCountDown,
  };
}
